import * as _ from "lodash"; 
import { appRouteConstants } from "app/app.route.constants";
import { getServiceConfig } from './service.config';
import { IAppConfig } from 'portalServices';

/**
 * Return an app config object for the web client.  This method creates a bespoke object that contains the necessary
 * client side configuration data (some observable bases) so that the service layer can configure itself properly based
 * on the client
 *
 * @returns {IAppConfig}
 */
export function getWebServiceConfig(): IAppConfig
{
    const webServiceConfig = getServiceConfig();
    
    // Ensure required properties exist
    return {
        apiEndpoint: webServiceConfig?.apiEndpoint || '',
        domainName: webServiceConfig?.domainName || '',
        ...webServiceConfig
    };
}